import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { MapPin, Home, Phone, Search } from "lucide-react";

const popularLinks = [
  { href: "/services/local-seo", label: "Local SEO Services" },
  { href: "/services/google-business-profile", label: "Google Business Profile" },
  { href: "/locations", label: "Service Locations" },
  { href: "/pricing", label: "Pricing Plans" },
  { href: "/contact", label: "Contact Us" },
  { href: "/blog", label: "SEO Blog" },
];

export default function NotFound() {
  return (
    <main
      id="main-content"
      className="min-h-screen bg-white flex items-center justify-center px-4 py-16"
      role="main"
      aria-labelledby="not-found-heading"
    >
      <div className="max-w-2xl w-full text-center">
        {/* Status code */}
        <div className="flex items-center justify-center mb-6">
          <span
            className="text-8xl font-black text-[#1B2A4A] leading-none select-none"
            aria-hidden="true"
          >
            404
          </span>
        </div>

        {/* Heading */}
        <h1
          id="not-found-heading"
          className="text-3xl font-bold text-[#1B2A4A] mb-4 font-['Playfair_Display']"
        >
          Page Not Found
        </h1>
        <p className="text-gray-600 text-lg mb-8 leading-relaxed">
          The page you are looking for may have been moved, renamed, or no longer exists.
          Use the links below to find what you need.
        </p>

        {/* Primary actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-10">
          <Button asChild size="lg" className="bg-[#1B2A4A] hover:bg-[#243660] text-white">
            <Link href="/">
              <Home className="w-4 h-4 mr-2" aria-hidden="true" />
              Back to Home
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-[#1B2A4A] text-[#1B2A4A] hover:bg-[#1B2A4A] hover:text-white">
            <Link href="/contact">
              <Phone className="w-4 h-4 mr-2" aria-hidden="true" />
              Talk to an Expert
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-[#c9a84c] text-[#c9a84c] hover:bg-[#c9a84c] hover:text-white">
            <Link href="/locations">
              <MapPin className="w-4 h-4 mr-2" aria-hidden="true" />
              Find Your City
            </Link>
          </Button>
        </div>

        {/* Popular links */}
        <nav aria-label="Popular pages">
          <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4 flex items-center justify-center gap-2">
            <Search className="w-4 h-4" aria-hidden="true" />
            Popular Pages
          </p>
          <ul className="grid grid-cols-2 sm:grid-cols-3 gap-2" role="list">
            {popularLinks.map((link) => (
              <li key={link.href}>
                <Link
                  href={link.href}
                  className="block text-sm text-[#1B2A4A] hover:text-[#c9a84c] underline underline-offset-2 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-[#c9a84c] focus:ring-offset-2 rounded"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </main>
  );
}
